// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../resources/point-image.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DataQualityToolSectionFour {
  padding: 60px 180px;
  background: #ffffff;
  height: auto;
  width: 100%;
  border-bottom: 1px solid gray;
}
.DataQualityToolSectionFour .DataQualityToolSectionFour-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
}
.DataQualityToolSectionFour .DataQualityToolSectionFour-head .DataQualityToolSectionFour-header {
  font-family: Roboto;
  font-size: 48px;
  font-weight: 400;
  line-height: 56px;
  letter-spacing: 0em;
  text-align: center;
  color: #1C2640;
}
.DataQualityToolSectionFour .DataQualityToolSectionFour-head .DataQualityToolSectionFour-sub {
  font-family: Roboto;
  font-size: 18px;
  font-weight: 400;
  line-height: 25px;
  letter-spacing: 0em;
  text-align: center;
  margin-top: 20px;
  color: #52667C;
}
.DataQualityToolSectionFour .DataQualityToolSectionFour-head .register-now-btn {
  width: 200px;
  height: 45px;
  font-size: 18px;
  font-weight: 400;
  margin-top: 10px;
}
.DataQualityToolSectionFour .DataQualityToolSectionFour-content {
  display: flex;
  flex: 1 1;
  flex-direction: row;
  margin-top: 70px;
  gap: 70px;
}
.DataQualityToolSectionFour .DataQualityToolSectionFour-content .DataQualityToolSectionFour-content-left {
  display: flex;
  flex: 1 1;
  flex-direction: column;
}
.DataQualityToolSectionFour .DataQualityToolSectionFour-content .DataQualityToolSectionFour-content-left .DataQualityToolSectionFour-content-left-features-list {
  font-family: Roboto;
  font-size: 18px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  color: #1C2640;
  padding-left: 17px;
  list-style-type: none;
}
.DataQualityToolSectionFour .DataQualityToolSectionFour-content .DataQualityToolSectionFour-content-left .DataQualityToolSectionFour-content-left-features-list li {
  position: relative;
  margin-bottom: 20px;
}
.DataQualityToolSectionFour .DataQualityToolSectionFour-content .DataQualityToolSectionFour-content-left .DataQualityToolSectionFour-content-left-features-list li::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-size: 10px;
  position: absolute;
  left: -50px;
}
.DataQualityToolSectionFour .DataQualityToolSectionFour-content .DataQualityToolSectionFour-content-right {
  display: flex;
  flex: 1 1;
  flex-direction: column;
}
.DataQualityToolSectionFour .DataQualityToolSectionFour-content .DataQualityToolSectionFour-content-right .DataQualityToolSectionFour-content-right-img {
  width: 100%;
  height: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/DataQualityTool/SectionFour/SectionFour.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;AACJ;AACI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AACR;AACQ;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AACZ;AAEQ;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAAZ;AAGQ;EACI,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AADZ;AAKI;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;AAHR;AAKQ;EACI,aAAA;EACA,SAAA;EACA,sBAAA;AAHZ;AAKY;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AAHhB;AAKgB;EACI,kBAAA;EACA,mBAAA;AAHpB;AAKoB;EACI,gDAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AAHxB;AASQ;EACI,aAAA;EACA,SAAA;EACA,sBAAA;AAPZ;AASY;EACI,WAAA;EACA,YAAA;AAPhB","sourcesContent":[".DataQualityToolSectionFour {\n    padding: 60px 180px;\n    background: #ffffff;\n    height: auto;\n    width: 100%;\n    border-bottom: 1px solid gray;\n\n    .DataQualityToolSectionFour-head {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        padding-top: 40px;\n\n        .DataQualityToolSectionFour-header {\n            font-family: Roboto;\n            font-size: 48px;\n            font-weight: 400;\n            line-height: 56px;\n            letter-spacing: 0em;\n            text-align: center;\n            color: #1C2640;\n        }\n\n        .DataQualityToolSectionFour-sub {\n            font-family: Roboto;\n            font-size: 18px;\n            font-weight: 400;\n            line-height: 25px;\n            letter-spacing: 0em;\n            text-align: center;\n            margin-top: 20px;\n            color: #52667C;\n        }\n\n        .register-now-btn {\n            width: 200px;\n            height: 45px;\n            font-size: 18px;\n            font-weight: 400;\n            margin-top: 10px;\n        }\n    }\n\n    .DataQualityToolSectionFour-content {\n        display: flex;\n        flex: 1;\n        flex-direction: row;\n        margin-top: 70px;\n        gap: 70px;\n\n        .DataQualityToolSectionFour-content-left {\n            display: flex;\n            flex: 1;\n            flex-direction: column;\n\n            .DataQualityToolSectionFour-content-left-features-list {\n                font-family: Roboto;\n                font-size: 18px;\n                font-weight: 400;\n                line-height: 21px;\n                text-align: left;\n                color: #1C2640;\n                padding-left: 17px;\n                list-style-type: none;\n\n                & li {\n                    position: relative;\n                    margin-bottom: 20px;\n\n                    &::before {\n                        content: url(\"../../../resources//point-image.svg\");\n                        font-size: 10px;\n                        position: absolute;\n                        left: -50px;\n                    }\n                }\n            }\n        }\n\n        .DataQualityToolSectionFour-content-right {\n            display: flex;\n            flex: 1;\n            flex-direction: column;\n\n            .DataQualityToolSectionFour-content-right-img {\n                width: 100%;\n                height: auto;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
